<template>
  <div>
    <modal :show.sync="modal"  body-classes="p-0"
               modal-classes="modal-dialog-centered modal-sm">
      <template slot="header">
         <h5 class="modal-title">密码修改</h5>
      </template>
      <card type="secondary" shadow
                        header-classes="bg-white pb-5"
                        body-classes="px-lg-5 py-lg-5"
                        class="border-0">
    	
      <form role="form" @keyup.enter="handleSubmit">
          <base-input alternative
                      type="password"
                      placeholder="旧登陆密码"
                      :error="passerr"
                      v-model="form.oldPassword"
                      addon-left-icon="ni ni-lock-circle-open">
          </base-input>
          <base-input alternative
                      type="password"
                      placeholder="新登陆密码"
                      :error="passerr"
                      v-model="form.password"
                      addon-left-icon="ni ni-lock-circle-open">
          </base-input>
          <base-input alternative
                      type="password"
                      placeholder="确认新登陆密码"
                      :error="repasserr"
                      v-model="form.re_password"
                      addon-left-icon="ni ni-lock-circle-open">
          </base-input>
          <div class="text-center">
              <base-button type="primary" class="my-4" @click="handleSubmit">确认密码修改</base-button>
          </div>
      </form>
    </card>
    </modal>
    <modal :show.sync="modals_alert" type="mini" modal-classes="modal-success modal-dialog-centered modal-sm">
         <template slot="header">
            <h5 class="modal-title">提示</h5>
         </template>
         <div>
          {{modals_text}}
         </div>
         <template slot="footer">
             <!-- <base-button type="secondary" @click="modals.alert = false">关闭</base-button> -->
             <!-- <base-button type="primary">Save changes</base-button> -->
         </template>
    </modal>
  </div>
</template>
<script>
import moment from 'moment'
import Modal from "@/components/Modal.vue";
import { mapActions } from 'vuex'
export default {
    name: 'LoginForm',
    components: {
    	Modal
    },
    data () {
      return {
      	modal: false,
        timer: null,
        loading: false,
        modals_alert: false,
        modals_text: '密码修改成功',
        form: {
          repassword: '',
          password: '',
        },
        passerr: '',
        emailerr: '',
        codeerr: '',
        repasserr: '',
      }
    },
    methods: {
      ...mapActions([
        'repassword'
      ]),
      open(){
      	this.modal = true
      	this.form = {
      		repassword: '',
      		password: ''
      	}
      },
      close(){
      	this.modal = false
      },
      async handleSubmit () {
        let { oldPassword, password, re_password } = this.form
        this.emailerr = ''
        this.passerr = ''
        if(!oldPassword){
            this.emailerr = '旧登陆密码不能为空，请核对！'
            return
        }
        if(oldPassword === password){
            this.passerr = '新旧登陆密码不能一样，请核对！'
            return
        }
        if(!password){
            this.passerr = '登陆密码不能为空，请核对！'
            return
        }
        if(password !== re_password){
            this.passerr = '两次密码不一样，请核对！'
            return
        }
        try{
          await this.repassword({ oldPassword, password })
        	this.close()
        	this.modals_alert = true
        	this.modals_text = "密码修改成功"
        } catch (err) {
          console.log(err)            
        }
      }
 	}    
}
</script>
<style>
.pr{
    position: relative;
}
.code-btn{
    position: absolute;
    z-index: 10;
    top: 0.6rem;
    right: 1rem;
}
</style>
